String.prototype.toCropUrl = function(width: number, height: number): string {
  const str = String(this);
  const widthRgx = new RegExp("(width=)(\\d+)");
  const heightRgx = new RegExp("(height=)(\\d+)");

  let result = str;

  if (widthRgx.test(str)) {
    result = result.replace(widthRgx, `width=${width}`);
  } else {
    result = AddToQueryString(result, `width=${width}`);
  }

  if (heightRgx.test(str)) {
    result = result.replace(heightRgx, `height=${height}`);
  } else {
    result = AddToQueryString(result, `height=${height}`);
  }

  return result;
};

function AddToQueryString(str: string, qsValue: string): string {
  if (str.indexOf("?") > -1) {
    str += `&${qsValue}`;
  } else {
    str += `?${qsValue}`;
  }
  return str;
}
